import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../common/Sidebar';
import { AdminGetCustomerById } from '../../Api/Admin/authServices';
import Loader from '../../component/common/Loader';


const CustomerDetailsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [customer, setCustomer] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchCustomer = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem('token');
                const response = await AdminGetCustomerById(token, id);
                setCustomer(response.user);
            } catch (error) {
                console.error('Error fetching customer:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCustomer();
    }, [id]);


    return (
        <div className="flex min-h-screen">
            <Sidebar />

            <div className="flex-1 p-6 bg-gray-50" style={{ marginLeft: '16rem' }}>
                <div className="text-2xl font-semibold mb-6">Customer Details</div>
                {loading ? <Loader /> :
                    <div className="p-6 bg-white shadow rounded">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Name</label>
                                <div className="mt-1 px-4 py-2 border border-gray-300 rounded-md bg-gray-50">
                                    {customer.fullName}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Email</label>
                                <div className="mt-1 px-4 py-2 border border-gray-300 rounded-md bg-gray-50">
                                    {customer.email}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Contact Number</label>
                                <div className="mt-1 px-4 py-2 border border-gray-300 rounded-md bg-gray-50">
                                    {customer.contactNumber}
                                </div>
                            </div>
                            {/* <div>
                                <label className="block text-sm font-medium text-gray-700">Address</label>
                                <div className="mt-1 px-4 py-2 border border-gray-300 rounded-md bg-gray-50">
                                    {customer?.address || "No address found"}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Total Orders</label>
                                <div className="mt-1 px-4 py-2 border border-gray-300 rounded-md bg-gray-50">
                                    {customer?.orders?.length || 0}
                                </div>
                            </div> */}
                        </div>
                        <div className="mt-6">
                            <button
                                onClick={() => navigate(-1)}
                                className="px-4 py-2 bg-gray-600 text-white rounded-md shadow hover:bg-gray-700 focus:outline-none"
                            >
                                Back
                            </button>
                        </div>
                    </div>

                }
            </div>
        </div>
    );
};

export default CustomerDetailsPage;
